import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { Actions, Getters, Mutations, ModalBannerState } from '@/interfaces/store/modalBanner'
import { RootState } from '@/interfaces/store/root'
import ModalBannerOptions from '@/interfaces/modal-banner-options'
import EventCodeConfigs from '@/interfaces/event-code-configs'
import * as EventCodeConfigsService from '@/services/event-code-configs'

export const state: ModalBannerState = {
  isModalActive: false,
  modalOptions: undefined,
  eventCodeConfigs: [],
  isUnlinkActive: false
}

export const getters: GetterTree<ModalBannerState, RootState> & Getters = {}
export const actions: ActionTree<ModalBannerState, RootState> & Actions = {
  onOpen({ commit }, options: ModalBannerOptions) {
    commit('updateModalOptions', options)
    commit('updateModalActive', true)
  },
  onClose({ commit }) {
    commit('updateModalActive', false)
  },
  async fetchEventCodeConfigsList({ commit }) {
    commit('updateEventCodeConfigsList', [])
    try {
      const result = await EventCodeConfigsService.getEventCodeConfigs()
      const statusCode = result.httpStatusCode
      if (statusCode === 200) {
        if (result.json && result.json.length > 0) {
          commit('updateEventCodeConfigsList', result.json)
        }
      } else {
        throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
      }
    } catch (error) {
      console.log(error)
    }
  },
}

export const mutations: MutationTree<ModalBannerState> & Mutations = {
  updateModalActive(state: ModalBannerState, isModalActive: boolean) {
    state.isModalActive = isModalActive
  },
  updateModalOptions(state: ModalBannerState, modalOptions: ModalBannerOptions) {
    state.modalOptions = modalOptions
  },
  updateEventCodeConfigsList(state: ModalBannerState, itemList: EventCodeConfigs[]) {
    state.eventCodeConfigs = itemList
  },
  updateUnlinkActive(state: ModalBannerState, isUnlinkActive: boolean) {
    state.isUnlinkActive = isUnlinkActive
  },
}

export const store: Module<ModalBannerState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}